import { makeVar } from '@apollo/client';

// this is for the balance banner animation if a policy got synced when they were not on page
const showSyncedAnimation = makeVar<number | undefined>(undefined);
export default showSyncedAnimation;
